import { render, staticRenderFns } from "./RequestMfaForm.vue?vue&type=template&id=4040c422"
import script from "./RequestMfaForm.vue?vue&type=script&lang=js"
export * from "./RequestMfaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports